import BaseCtrl from 'edge/platform/base/BaseCtrl';

var fn = function fn($scope) {
    var ctrl = Object.create(BaseCtrl);

    return ctrl.create($scope);
};
fn.$inject = ['$scope'];

export default fn;


//////////////////
// WEBPACK FOOTER
// ./common/js/src/edge/gateway/controllers/account/BillingCtrl.js
// module id = 1691
// module chunks = 0